import React from 'react';
import { Preloader, Control, Link } from "MWComponents";
import Calculator from '../../../auxiliary-components/Calculator';
import '../less/main.less';
import Breadcrumbs from "../../../auxiliary-components/Breadcrumbs";
import { MAIN, CREDIT, PAWNSHOP } from "../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config";
import clearBR from "../../../helpers/utils/clearBR";
import { get } from '../../../config';
import {LANG} from '../../../services/l10n';

export default function template() {
    const model = this.getModel(),
        lang = get('LANG') === LANG.UA ? LANG.UK : LANG.RU,
        urlFrame = 'https://map.a-bank.com.ua/?lang=' + lang,
        pathToEssentialCharacteristicsFolder = '/static/essential_characteristics',
        pawnshopFile = this.props.lang === LANG.UA ?
            "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/ZDM/Istot_ZDM_ua.pdf" :
            "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/ZDM/Istot_ZDM_ru.pdf",
        pawnshopFile4 = this.props.lang === LANG.UA ?
            'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/ZDM_ua.pdf' :
            'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/ZDM_ru.pdf',
        pawnshopFile5 = this.props.lang === LANG.UA ?
            'https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/ZDM/Pasport_ZDM.pdf' :
            'https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/ZDM/Pasport_ZDM.pdf',
        isMobile = this.isViewportMobile(),
        creditDescriptionOne = isMobile ? clearBR(this.l10n("CREDIT_PAWNSHOP_DESC_1")) : this.l10n("CREDIT_PAWNSHOP_DESC_1"),
        creditDescriptionTwo = isMobile ? clearBR(this.l10n("CREDIT_PAWNSHOP_DESC_2")) : this.l10n("CREDIT_PAWNSHOP_DESC_2"),
        links = [MAIN, CREDIT, PAWNSHOP];

    return !model.alloy ?
        (<div className="preload-wrapper">
            <Preloader />
        </div>)
        :
        (<div className="credit-calculator pawnshop">
            <Breadcrumbs links={links} {...this.props} />
            <div className="banner">
                <div className="banner-content">
                    <div className="banner-title" dangerouslySetInnerHTML={{ __html: this.l10n('CREDIT_PAWNSHOP_BANNER_TITLE') }} />
                    <div className="banner-message">{this.l10n('CREDIT_PAWNSHOP_BANNER_MESSAGE')}</div>
                    <Link href={`/credit`} onClick={e => this.context.app.navigate(`/credit`, e)}>
                        <div className="backward-btn">{this.l10n('CREDIT_PAWNSHOP_BANNER_BACKWARD')}</div>
                    </Link>
                </div>
            </div>
            <div className="content">
                <div className="credit-description">
                    <p className="credit-description-title block-title">{this.l10n('CREDIT_PAWNSHOP_IS')}</p>
                    <p className="credit-description-item" dangerouslySetInnerHTML={{ __html: this.l10n(creditDescriptionOne) }} />
                    <p className="credit-description-item" dangerouslySetInnerHTML={{ __html: this.l10n(creditDescriptionTwo) }} />
                </div>

                <div className="credit-offer">
                    <p className="block-title">{this.l10n('CREDIT_PAWNSHOP_OFFER')}</p>
                    <div className="credit-offer-body grid">
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TITLE_1')}
                                <span className="upper">{this.l10n('CREDIT_PAWNSHOP_UAH')}</span>
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TEXT_1')}
                            </p>
                        </div>
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TITLE_2')}
                                <span className="upper">{this.l10n('CREDIT_PAWNSHOP_DAYS')}</span>
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TEXT_2')}
                            </p>
                        </div>
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TITLE_3')}
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TEXT_3')}
                            </p>
                        </div>
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TITLE_4')}
                                <span className="upper">{this.l10n('CREDIT_PAWNSHOP_PERCENT')}</span>
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_PAWNSHOP_OFFER_TEXT_4')}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="credit-calculator">
                    <p className="block-title">{this.l10n('CREDIT_INSTALLMENT_CALC')}</p>
                    <div className="calculator-wrapper">
                        <Calculator model={model}  {...this.props} type={this.state.selectedType} />
                    </div>
                </div>

                <div className="credit-instruction">
                    <p className="block-title">{this.l10n('CREDIT_QUICK_CASH_INSTRUCTION_TITLE')}</p>
                    <div className="credit-instruction-body green-card">
                        <div className="line" />
                        <div className="credit-instruction-body-item">
                            <div className="item-figure one"></div>
                            <p className="item-title centered">{this.l10n('CREDIT_PAWNSHOP_INSTRUCTION_ITEM_1_TITLE')}</p>
                            <p className="item-description"
                                dangerouslySetInnerHTML={{ __html: this.l10n('CREDIT_PAWNSHOP_INSTRUCTION_ITEM_1_TEXT') }}></p>
                            <div className="dot" />
                            <div className="bullet" />
                        </div>
                        <div className="credit-instruction-body-item">
                            <div className="item-figure two"></div>
                            <p className="item-title centered">{this.l10n('CREDIT_PAWNSHOP_INSTRUCTION_ITEM_2_TITLE')}</p>
                            <p className="item-description">{this.l10n('CREDIT_PAWNSHOP_INSTRUCTION_ITEM_2_TEXT')}</p>
                            <div className="dot" />
                            <div className="bullet" />
                        </div>
                        <div className="credit-instruction-body-item">
                            <div className="item-figure three"></div>
                            <p className="item-title centered">{this.l10n('CREDIT_PAWNSHOP_INSTRUCTION_ITEM_3_TITLE')}</p>
                            <div className="item-description">{this.l10n('CREDIT_PAWNSHOP_INSTRUCTION_ITEM_3_TEXT')}
                            </div>
                            <div className="dot" />
                            <div className="bullet" />
                        </div>
                    </div>
                </div>

                <div className="credit-payment">
                    <p className="block-title">{this.l10n('CREDIT_PAWNSHOP_PAYMENT_TITLE')}</p>
                    <div className="credit-payment-body" style={{ flexDirection: "row" }}>
                        <div className="credit-payment-body-item">
                            <div className="item-img columns"></div>
                            <div className="item-text">{this.l10n('CREDIT_PAWNSHOP_PAYMENT_ITEM_1')}</div>
                        </div>
                        <div className="credit-payment-body-item">
                            <div className="item-img phone"></div>
                            <div className="item-text">{this.l10n('CREDIT_PAWNSHOP_PAYMENT_ITEM_2')}</div>
                        </div>
                    </div>
                </div>

                <div className="credit-files">
                    <p className="block-title">{this.l10n('CREDIT_FILES_TO_LOAD')}</p>
                    <div className="files">
                        <Control>
                            <div className="files-item">
                                <Link href={`${pawnshopFile}`}
                                    target="_blank" >
                                    {this.l10n('CREDIT_PAWNSHOP_FILES_ITEM_2')}
                                </Link >
                            </div >
                            <div className="files-item">
                                <Link href={`https://conditions-and-rules.a-bank.com.ua/main/view-content-389/?lang=uk`}
                                    target="_blank">
                                    {this.l10n('CREDIT_PAWNSHOP_FILES_ITEM_3')}
                                </Link>
                            </div>
                            <div className="files-item">
                                <Link href={pawnshopFile5}
                                    target="_blank">
                                    {this.l10n('CREDIT_PAWNSHOP_FILES_ITEM_5')}
                                </Link>
                            </div>
                            <div className="files-item">
                                <Link href={pawnshopFile4}
                                    target="_blank">
                                    {this.l10n('CREDIT_PAWNSHOP_FILES_ITEM_4')}
                                </Link>
                            </div>
                        </Control >
                    </div >
                </div >
                <div id="map" className="map">
                    <p className="block-title">{this.l10n('CREDIT_PAWNSHOP_FIND_US')}</p>
                </div>
            </div >
            <div className="map-wrapper">
                <iframe
                    src={urlFrame}
                    scrolling="no"
                    frameBorder="0"
                    width="100%"
                    height="900px"
                    style={{ margin: '0 auto', display: 'block' }}
                />
            </div>
            <div className="content">
                <div className="prescription" style={{ marginTop: 0 }}>
                    <p className="prescription-item">{this.l10n('CREDIT_PAWNSHOP_PRESCRIPTTION_1')}</p>
                    <p className="prescription-item">{this.l10n('CREDIT_PAWNSHOP_PRESCRIPTTION_2')}</p>
                    <p className="prescription-item">{this.l10n('CREDIT_PAWNSHOP_PRESCRIPTTION_3')}</p>
                    <p className="prescription-item">{this.l10n('CREDIT_PAWNSHOP_PRESCRIPTTION_4')}</p>
                    <p className="prescription-item">{this.l10n('CREDIT_PAWNSHOP_PRESCRIPTTION_5')}</p>
                </div>
            </div>
        </div >);
}
